













import ApiClient from '@/js/api.js'
import PopupCircleEpisode from '@/views/templates/africadogs/PopupCircleEpisode.vue'

export default
  components: {
    PopupCircleEpisode
  }

  data: () ->
    message: [
      'AFURIKA DOGSさんに到着したよ！'
      'いや～ここにはカラフルな布がたくさんあるなぁ。'
      'アフリカと日本を繋ぐ取り組みって'
      '一体どんなことだろうね。'
      ''
      'クイズに答えてもらったポイントは'
      'お店で使えるからぜひ集めてみてね！'
      ''
      'あ、あの人が中須さんかな？'
    ]

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    addPoint: (point) ->
      @$emit('addPoint', point)
  }
